// extracted by mini-css-extract-plugin
export default {"f":"_383d3d7ea0","main":"_53f69b1e84","btn":"cdc6b16f66","w":"_9d7685b73e","h":"_1f61a119d9","lh25":"_29f6e0819c","wb":"_351ddcdc6a","b":"_4e18d5958a","bx":"_445f62b90a"};